export default "__VITE_ASSET__21c33381__"